import React, { useState,useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AppState } from '../store/configureStore';
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { applicationTimeoutActionCreators } from '../store/ApplicationTimeoutStore';
import { dcrActionCreators } from '../store/DCRStore';
import { connect } from 'react-redux';
import { stateLoading } from '../functions/stateLoading';

function convertToMilliseconds(minutes: number): number {
    return minutes * 60 * 1000;
}

// eslint-disable-next-line
type TSessionTimeoutModalProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const SessionTimeoutModal = function (props: TSessionTimeoutModalProps) {
    const [isShowing, setIsShowing] = useState(false);
    const [isLogoff, setIsLogoff] = useState(false);
    const { logoffMinutes, logoffWarningMinutes } = props.timeoutData;

    useEffect(() => {
        if (stateLoading(props.timeoutData)) {
            props.fetchApplicationTimeout();
        }
    }, [props.timeoutData.loadState])

    useEffect(() => {
        let showTimer: NodeJS.Timeout;
        let logoffTimer: NodeJS.Timeout;
        if (!isShowing) {
            if (logoffWarningMinutes && !stateLoading(props.timeoutData)) {
                showTimer = setTimeout(() => setIsShowing(true), convertToMilliseconds(logoffWarningMinutes));
            }
        }

        if (isLogoff) {
            // eslint-disable-next-line
            clearTimeout(logoffTimer!);
            // eslint-disable-next-line
            logoff();
        } else {
            // eslint-disable-next-line
            clearTimeout(logoffTimer!);
            if (logoffMinutes && !stateLoading(props.timeoutData)) {
                logoffTimer = setTimeout(() => setIsLogoff(true), convertToMilliseconds(logoffMinutes));
            }
        }
        return () => {
            clearTimeout(showTimer);
            clearTimeout(logoffTimer);
        }
    }, [isShowing, isLogoff, props.timeoutData.loadState])

    if (stateLoading(props.timeoutData)) {
        return null;
    }

    function logoff() {
        props.logout();
    }

    return (
        <Modal show={isShowing} backdrop="static" centered >
            <Modal.Header>
                <Modal.Title>Session about to expire</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-left">
                {'Your online session will expire in approximately one minute.Click "Keep me logged in" to continue your online session or click "Log out now" to end your session now.'}
            </Modal.Body>
            <Modal.Footer className="justify-content-start">
                <Button className="mr-3" variant="primary" onClick={() => setIsShowing(false)}>Keep me logged in</Button>
                <Button variant="link" onClick={logoff}>Log out now</Button>
            </Modal.Footer>
        </Modal>
    );
};

function mapStateToProps(state: AppState) {
    return {
        timeoutData: state.applicationTimeout.applicationTimeout
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...applicationTimeoutActionCreators, ...dcrActionCreators }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SessionTimeoutModal);